/* Hushbird quiz behaviour.
   1. Routes the finished quiz to the right collection.
   2. Stops the theme jumping to the top of the page on every answer. */
(function () {
  var DEFAULT_HANDLE = '1-focus-track';
  var BUNDLE_HANDLE = 'bundle-save';

  /* Age answer (Q1) + how they play (Q2) together pick the collection.
     Each age band walks its own three steps of the skill sequence.
     7-thread-sequence is deliberately left out: its products are all busy
     books currently tagged 0-12 months, so routing there would mismatch. */
  var AGE_IDS = {
    quiz_answer_8Xqn4a: '0-12',
    quiz_answer_bYgWma: '12-24',
    quiz_answer_mrYABg: '2-3+'
  };
  var PLAY_IDS = {
    answer_play_watch: 'watch',
    answer_play_grab: 'grab',
    answer_play_work: 'work'
  };
  var ROUTES = {
    '0-12':  { watch: '1-focus-track',    grab: '2-reach-grasp',    work: '3-find-release' },
    '12-24': { watch: '3-find-release',   grab: '4-post-stack',     work: '5-match-fit' },
    '2-3+':  { watch: '5-match-fit',      grab: '6-pinch-transfer', work: '8-build-write' }
  };

  /* Legacy: the original Q2 that named the skill directly. Kept so routing
     still works if an older template is ever served. */
  var SKILL_MAP = {
    answer_skill_focus_track: '1-focus-track',
    answer_skill_reach_grasp: '2-reach-grasp',
    answer_skill_find_release: '3-find-release',
    answer_skill_post_stack: '4-post-stack',
    answer_skill_match_fit: '5-match-fit',
    answer_skill_pinch_transfer: '6-pinch-transfer',
    answer_skill_thread_sequence: '7-thread-sequence',
    answer_skill_build_write: '8-build-write'
  };

  function store() {
    return window.Alpine && window.Alpine.store && window.Alpine.store('quiz');
  }

  /* Shopify prefixes nested block ids, e.g.
     "AVHVUeWtCZXRPa1pnV__answer_play_grab",
     so always compare on the part after the last "__". */
  function bareId(id) {
    return String(id).split('__').pop();
  }

  function chosenAnswers(s) {
    var answers = (s && s.answers) || {};
    var out = [];
    Object.keys(answers).forEach(function (pageId) {
      (answers[pageId] || []).forEach(function (id) { out.push(bareId(id)); });
    });
    return out;
  }

  function computeRedirect(s) {
    var chosen = chosenAnswers(s);
    if (chosen.indexOf('answer_path_bundle') !== -1) {
      return '/collections/' + BUNDLE_HANDLE;
    }

    var age = null, play = null, legacy = null;
    chosen.forEach(function (id) {
      if (AGE_IDS[id]) age = AGE_IDS[id];
      if (PLAY_IDS[id]) play = PLAY_IDS[id];
      if (SKILL_MAP[id] && !legacy) legacy = SKILL_MAP[id];
    });

    var handle = DEFAULT_HANDLE;
    if (age && play && ROUTES[age] && ROUTES[age][play]) {
      handle = ROUTES[age][play];
    } else if (legacy) {
      handle = legacy;
    }
    return '/collections/' + handle;
  }

  /* The theme dispatches this the moment the loading screen becomes the active
     step: after every answer is recorded, before it calls quiz.next(). */
  document.addEventListener('quiz-loading:start', function (event) {
    var s = store();
    if (!s || !s.setPageRedirect || !event.detail) return;
    s.setPageRedirect(event.detail, computeRedirect(s));
  });

  /* ---- keep the quiz in view ------------------------------------------
     quiz.next()/prev()/complete() each call window.scrollTo({top:0}), which
     is right for a standalone quiz page but wrong here, where the quiz sits
     near the bottom of the home page. Swallow that call and re-anchor on the
     question instead. */
  function activeStepEl(s) {
    if (!s || !s.pages) return null;
    var id = s.pages[s.currentStep];
    if (!id) return null;
    return document.getElementById('quiz-page-' + id) ||
           document.getElementById('quiz-loading-' + id);
  }

  function keepInView(s) {
    requestAnimationFrame(function () {
      var el = activeStepEl(s);
      if (!el) return;
      var top = el.getBoundingClientRect().top;
      /* already sitting comfortably on screen - leave the page alone */
      if (top >= 0 && top < window.innerHeight * 0.5) return;
      window.scrollTo({
        top: Math.max(0, window.pageYOffset + top - 80),
        behavior: 'smooth'
      });
    });
  }

  function stopTopJump(s) {
    ['next', 'prev'].forEach(function (name) {
      var original = s[name];
      if (typeof original !== 'function' || original.__hbNoJump) return;
      var wrapped = function () {
        var realScrollTo = window.scrollTo;
        window.scrollTo = function () {};
        try {
          return original.apply(s, arguments);
        } finally {
          window.scrollTo = realScrollTo;
          keepInView(s);
        }
      };
      wrapped.__hbNoJump = true;
      s[name] = wrapped;
    });
  }

  var tries = 0;
  (function waitForStore() {
    var s = store();
    if (s && typeof s.next === 'function') { stopTopJump(s); return; }
    if (++tries > 120) return;
    setTimeout(waitForStore, 50);
  })();
})();
